// import Account from "@/helper/AccountHelper.js";
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import CacheHelper from "@/helper/CacheHelper.js";
export default {
    data() {
        return {
            cacheHelper: new CacheHelper(),
            idToken: null,
            checkRegister: null,
            getDataEmtry: null
        }
    },
    mounted: function() {
        var cacheHelper = new CacheHelper("cookie");
        this.idToken = cacheHelper.getCache("linetoken");
        this.checkRegister = cacheHelper.getCache("BzbsUser");
        if (this.checkRegister == null) {
            if  (this.$route.query.target_page){
                window.location.replace("/linelogin"+"?target_page="+this.$route.query.target_page);
            } else {
                this.$router.push("/linelogin" + "?target_page=privilege");
            } 
        }
        this.idToken = cacheHelper.getCache("linetoken");
        this.apiLoginLine(this.idToken);
    },
    created() {
    },
    methods: {
        apiLoginLine: async function(idToken) {
            // return new Promise((resolve) => {
                BzbsAuth.apiLoginLineService(idToken).subscribe(
                    data => {
                        this.getDataEmtry = data // ใส่ไว้ป้องกัน error หาตัวแปรไม่เจอ

                    //     Account.setLogin(data,  'data');
                    //     resolve(data, 'data');
                    //     // window.location.replace("/privilege");
                    },
                    err => {
                        if  (this.$route.query.target_page){
                            window.location.replace("/linelogin"+"?target_page="+this.$route.query.target_page);
                        } else {
                            this.$router.push("/linelogin" + "?target_page=privilege");
                        } 
                        console.log('err apiLoginLineService :: ',err);
                    }
                );
            // });
        },
    },
  }
